import React from 'react';
import { Link } from 'react-router-dom';
import theme from '@jetshop/ui/utils/theme';
import styled from 'react-emotion';
import Image from '@jetshop/ui/Image';
import t from '@jetshop/intl';

const Wrapper = styled('li')`
  margin: 1rem;
  a {
    color: #000;
    text-decoration: none;
  }
  h2 {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  span {
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

const Text = styled('div')`
  background: ${theme('colors.background')};
  padding: 1rem;
  p {
    display: block;
    min-height: 48px;
  }
`;

const ReadMore = styled('button')`
  background-color: transparent;
  appearance: none;
  border: 0;
  color: black;
  font-size: 1rem;
  font-weight: bold;
  margin-top: 0.5rem;
  outline: none;
  letter-spacing: 0.5px;
  &:hover {
    color: ${theme('colors.primary')};
  }
`;

const decodeHtml = html => {
  var tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  if (tmp.getElementsByClassName('youtube-embed').length > 0) {
    tmp.getElementsByClassName('youtube-embed')[0].remove();
  }
  return tmp.textContent || tmp.innerText || '';
};

const AcademyCard = ({ post }) => {
  if (!post) return null;
  return (
    <Wrapper>
      <Link to={post.primaryRoute.path}>
        <Image
          aspect={'5:3'}
          cover={true}
          src={
            post.images.length > 0
              ? post.images[4].url
              : 'https://skistore.jetshop.se/pub_docs/files/Custom_Item_Images/Rectangle-14-(1).png'
          }
        />
        <Text>
          <span>{post.parent.name}</span>
          <h2>{post.name}</h2>
          {/* <p>{decodeHtml(post.content).substr(0, 100)}...</p> */}
          <ReadMore>{t('Läs mer')}</ReadMore>
        </Text>
      </Link>
    </Wrapper>
  );
};

export default AcademyCard;
